import { css } from "@emotion/react";

import { colors } from "../../../../styles";

export const office = css`
  background-color: ${colors.white};
  padding: 15px;
  border-radius: 5px;
  margin-top: 20px;
  margin-right: 20px;

  @media only screen and (max-width: 64em) {
    margin-right: 0;
  }
`;

export const header = css`
  font-size: 1.75rem;
  margin-bottom: 15px;
`;

export const address = css`
  color: ${colors.gray};
  font-weight: lighter;
`;

export const officeDetails = css`
  list-style-type: none;
  margin: 0;
  margin-top: 10px;
`;
